firebird.controller('browserNotSupportedCtrl', [
    '$window',
    '$location',
    '$timeout',
    'logService',
    'helperService',
    'meetingService',
    'config',
    'brandingService',
    function ($window, $location, $timeout, logService, helperService, meetingService, config, brandingService) {
        var self = this;

        self.meetingIdentifier = helperService.getMeetingIdentifier($location.absUrl());
        self.redirectURL =
            config.mobileURLSchemes.direct +
            '://meeting.' +
            helperService.getLocationHost() +
            '/' +
            self.meetingIdentifier;
        self.deviceType = helperService.getDeviceType();
        self.appstoreurl = '';
        self.appName = 'AnyMeeting';
        self.appFullName = 'Intermedia AnyMeeting';

        init();

        ////////////////////////

        function init() {
            var resellerCode = brandingService.getResellerCode();
            self.appName = brandingService.getCamaroAppName();
            self.appFullName = brandingService.getAppFullName();
            var mobileURLSchemes = config.mobileURLSchemes[resellerCode];

            if (brandingService.isPartner()) {
                self.redirectURL =
                    mobileURLSchemes + '://meeting.' + helperService.getLocationHost() + '/' + self.meetingIdentifier;
            }

            // Should be rewrite in story ANYAM-15776: Meeting App. Select mobile app in store (Apple, Google)
            if (self.deviceType === 'iPhone' || self.deviceType === 'iPad') {
                if (resellerCode === 'direct') {
                    self.appstoreurl = config.appStoreURLs.intermediaDirect.ios;
                } else if (resellerCode === 'plr') {
                    self.appstoreurl = config.appStoreURLs.intermediaPLR.ios;
                } else {
                    self.appstoreurl = config.appStoreURLs.amdirect.ios;
                }

                redirect(self.appstoreurl);
            } else if (self.deviceType === 'Android') {
                if ($window.navigator.userAgent.indexOf('Silk') !== -1) {
                    self.appstoreurl = config.appStoreURLs.amdirect.kindleV35;
                } else {
                    if (resellerCode === 'direct') {
                        self.appstoreurl = config.appStoreURLs.intermediaDirect.android;
                    } else if (resellerCode === 'plr') {
                        self.appstoreurl = config.appStoreURLs.intermediaPLR.android;
                    } else {
                        self.appstoreurl = config.appStoreURLs.amdirect.android;
                    }
                }

                redirect(self.appstoreurl);
            }
        }

        function redirect(fallbackURL) {
            //This will try to open app... if that fails,
            //then after 5 seconds we will open app store URL

            logService.log('Trying to open mobile app via custom url scheme: ' + self.redirectURL);
            $window.location.href = self.redirectURL;

            $timeout(function () {
                logService.log('Fall back link: ' + fallbackURL);
                meetingService.openExternalLink(fallbackURL);
            }, 5000);
        }
    }
]);
